import React, { useContext, useEffect, useState } from 'react';
import Select, { createFilter } from 'react-select';
import CustomOption from '../../utils/Elements/CustomOption';
import { CountContext, ParentContext, CompanyContext, ActivityContext } from '../../layouts/Dashboard/LayoutDashboard';
import { Pagination, Button, FloatingLabel, Nav } from 'react-bootstrap';
import { OrderCard } from './OrderCard';
import { OrderForm } from './OrderForm';
import { OrderSearch } from './OrderSearch';
import { AlertElement } from '../../utils/Elements/AlertElement';
import { ToggleButton } from '../../utils/Elements/ToggleButton';
import { toast } from 'react-toastify';
import { jwtDecode } from 'jwt-decode';
import '../Pages.css';

export const Orders = () => {
  const api = process.env.REACT_APP_API_ENDPOINT;
  const mc3 = process.env.REACT_APP_MC3_ENDPOINT;
  const ordersPagedEndpoint = `${api}/v1/orders/paged`;
  const ordersCompanyUid = `${api}/v1/orders/getUid/`;
  const ordersExportEndpoint = `${mc3}/v1/Exports/Orders/`;
  // State management
  const { setOrderCount } = useContext(CountContext);
  const { selectedParentID, setSelectedParentID } = useContext(ParentContext);
  const { selectedCompanyID, selectedCompanyParentID, setSelectedCompanyID, setSelectedCompanyParentID } = useContext(CompanyContext);
  const { searchOptions, setSearchOptions } = useContext(ActivityContext);
  const [orders, setOrders] = useState([]);

  const [allCollapsed, setAllCollapsed] = useState(0);
  const [userCollapsed, setUserCollapsed] = useState(false);
  const [collapseButtonText, setCollapseButtonText] = useState('Collapse All');

  const [showOrderForm, setOrderForm] = useState(false);
  const [orderSelected, setOrderSelected] = useState({});

  //display options dropdown
  const [displayOptions] = useState([
    { value: 20, label: "20 Lines" },
    { value: 50, label: "50 Lines" },
    { value: 100, label: "100 Lines" },
    { value: 200, label: "200 Lines" }
  ]);
  const [displayOption, setDisplayOption] = useState(displayOptions[0]);

  //sort options dropdown
  const [sortOptions] = useState([
    { value: 0, order: "Priority", order_direction: "asc", label: "Priority" },
    { value: 1, order: "Order Date", order_direction: "asc", label: "Order Date asc" },
    { value: 2, order: "Order Date", order_direction: "desc", label: "Order Date desc" },
    { value: 3, order: "Order-Line", order_direction: "asc", label: "Order-Line asc" },
    { value: 4, order: "Order-Line", order_direction: "desc", label: "Order-Line desc" },
    { value: 5, order: "Ship Date", order_direction: "asc", label: "Ship Date asc" },
    { value: 6, order: "Ship Date", order_direction: "desc", label: "Ship Date desc" },
    { value: 7, order: "Delivery Date", order_direction: "asc", label: "Delivery Date asc" },
    { value: 8, order: "Delivery Date", order_direction: "desc", label: "Delivery Date desc" },
  ]);
  const [sortOption, setsortOption] = useState(sortOptions[0]);

  const [filterTotal, setfilterTotal] = useState(0);

  //paginaton
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalDisplayed, setTotalDisplayed] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const [loading, setLoading] = useState(false); //this dims cards when they are dgin refreshed

  const [filterDescription, setFilterDescription] = useState('');
  const [noRecordsMessage, setNoRecordsMessage] = useState('');
  const [showSearchForm, setSearchForm] = useState(false);
  // Functions to handle pagination
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const handleFirstPage = () => {
    setCurrentPage(1);
  };
  const handlePrevPage = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };
  const handleNextPage = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };
  const handleLastPage = () => {
    setCurrentPage(totalPages);
  };

  //collapse management
  const collapseAll = () => {
    if (!userCollapsed) setAllCollapsed(1);
  };
  const expandAll = () => {
    if (!userCollapsed) setAllCollapsed(0);
  };
  const handleToggleCollapse = () => {
    setUserCollapsed(true);
    setAllCollapsed(1 - allCollapsed);
  };

  // Function to handle the change in cards per page
  const handleDisplayChange = (option) => {
    setDisplayOption(option);
    setCurrentPage(1); // Reset to the first page
    option.value >= 50 ? collapseAll() : expandAll();
  };

  // Function to handle Sort change
  const handleSortChange = (option) => {
    setsortOption(option);
  };

  // Pagination Carousel
  const renderPaginationItems = () => {
    const maxVisibleItems = 5;
    const items = [];
    const startPage = Math.max(currentPage - Math.floor(maxVisibleItems / 2), 1);
    const endPage = Math.min(startPage + maxVisibleItems - 1, totalPages);

    for (let i = startPage; i <= endPage; i++) {
      items.push(
        <Pagination.Item
          key={i}
          active={i === currentPage}
          onClick={() => handlePageChange(i)}
        >
          {i}
        </Pagination.Item>
      );
    }

    return items;
  };

  const openOrderForm = (e, order) => {
    if (e) { e.preventDefault(); e.stopPropagation(); }
    setOrderSelected(order);
    setOrderForm(true);
  };

  const closeOrderForm = () => {
    setOrderForm(false);
    fetchOrders(); //refresh page
  };

  const formatDate = (dt) => {
    dt.setHours(0, 0, 0, 0);
    return dt;
  };

  const next = (days) => {
    var dt = new Date();
    dt.setDate(dt.getDate() + days);
    return formatDate(dt);
  };

  const getStoredToken = () => {
    return localStorage.getItem('token');
  };

  const storedToken = getStoredToken();

  //filters (set by search modal)
  const [orderFilters, setOrderFilters] = useState({
    parentId: 0, //selectedCompanyParentID ? selectedCompanyParentID : selectedParentID,
    companyId: 0, //selectedCompanyID,
    contactId: 0,
    contactName: "",
    salesRepId: 0,
    orderType: 0,
    status: -1,
    dateType: "order",
    dateRange: 0,
    dateRangeStart: formatDate(new Date('01/01/1980')),
    dateRangeEnd: next(7),
    sortBy: "Order Date",
    advertiser: "",
    size: "",
    design: "",
    shipping: "",
    description: "",
    reorder: "",
    part: "",
    unit: "",
    references: "",
    geopathid: "",
    invoice: "",
    order: 0,
    product: "",
    filterTotal: 0,
    applyFilter: false,
  });

  //load the page contact cards
  const fetchOrders = async () => {

    if (storedToken && (selectedParentID || selectedCompanyID)) {

      setLoading(true);

      const identity = jwtDecode(storedToken);
      let of = {};
      let sort = sortOption.order_direction;
      let sortBy = sortOption.order;
      if (searchOptions && searchOptions.mode) {
        console.log("set default search filters");
        of = setSearchFilters();
        setsortOption(sortOptions[1])
      }else{
        console.log("set new search filters: ",orderFilters);
        of = orderFilters;
      }
      console.log("of: ", of);
      const payload = {
        EmployeeUID: identity.sub,
        ParentID: selectedParentID ?? "",
        CompanyID: selectedCompanyID ?? "",
        PageNo: currentPage,
        PageSize: displayOption.value,
        SortBy: sortBy ?? "",
        SortOrder: sort ?? "",
        Filter_ParentID: of.parentId ?? "",
        Filter_CompanyID: of.companyId ?? "",
        Filter_ContactID: of.contactId ?? "",
        Filter_SalesRepID: of.salesRepId ?? "",
        Filter_Status: of.status ?? -1,
        Filter_DateRange: of.dateRange ?? "",
        Filter_DateType: of.dateType ?? "",
        Filter_DateStart: of.dateRangeStart ?? "",
        Filter_DateEnd: of.dateRangeEnd ?? "",
        Filter_Total: of.filterTotal ?? 0,
        Filter_Apply: of.applyFilter ?? false, 
        Filter_advertiser: of.advertiser ?? "",
        Filter_size: of.size ?? "",
        Filter_design: of.design ?? "",
        Filter_shipping: of.shipping ?? "",
        Filter_description: of.description ?? "",
        Filter_reorder: of.reorder ?? "",
        Filter_part: of.part ?? "",
        Filter_unit: of.unit ?? "",
        Filter_references: of.references ?? "",
        Filter_geopathid: of.geopathid ?? "",
        Filter_invoice: of.invoice ?? "",
        Filter_ProductNames: of.product ?? "",
        Filter_OrderNum: of.order ?? 0 
      };
      console.log("payload: ",payload)

      try {
        const response = await fetch(ordersPagedEndpoint, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${storedToken}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        });
        if (response.ok) {
          const data = await response.json();


          setOrders(data.Orders);
          setTotalRecords(data.TotalCount);
          setTotalDisplayed(Math.min(data.Orders.length, displayOption.value));
          setTotalPages(Math.ceil(data.TotalCount / displayOption.value));
          setOrderCount(data.UnfilteredCount);  //this sets the count on the upper nav bar
          setLoading(false);

        } else {
          setLoading(false);
          console.error('Failed to fetch orders');
          toast.error("Failed to load orders", {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 5000,
            paueOnHover: true,
            theme: 'colored'
          });
        }
      } catch (error) {
        setLoading(false);
        console.error('Failed to fetch orders', error);
        toast.error("Failed to load orders", {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 5000,
          paueOnHover: true,
          theme: 'colored'
        });
      }

    }
  };

  const requestPDFExport = async() => {
    if (storedToken && (selectedCompanyID)) {
      let uId = null
      try {
        const response = await fetch( ordersCompanyUid + selectedCompanyID, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${storedToken}`,
            'Content-Type': 'application/json',
          },
        });
        if (response.ok) {
          uId = await response.json();
        } else {
          failedCustomerUid();
        }
      } catch (error) {
        failedCustomerUid();
      }
      if (uId == null){
        failedCustomerUid();
        return
      }
      try {
        const response = await fetch(ordersExportEndpoint + uId, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/vnd.ms-excel',
          },
        });
        if (response.ok) {
          const blob = await response.blob();
          const url = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'filename.xlsx'); // specify the file name
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
        } else {
          toast.error("Failed to export orders", {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 5000,
            paueOnHover: true,
            theme: 'colored'
          });
        }
      } catch (error) {
        console.error('Failed to export orders', error);
        toast.error("Failed to export orders", {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 5000,
          paueOnHover: true,
          theme: 'colored'
        });
      }
    }
  }
  const requestExcelExport = async() => {
    if (storedToken && (selectedCompanyID)) {
      let uId = null
      try {
        const response = await fetch( ordersCompanyUid + selectedCompanyID, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${storedToken}`,
            'Content-Type': 'application/json',
          },
        });
        if (response.ok) {
          uId = await response.json();
        } else {
          failedCustomerUid();
        }
      } catch (error) {
        failedCustomerUid();
      }
      if (uId == null){
        failedCustomerUid();
        return
      }
      try {
        console.log(ordersExportEndpoint + uId)
        const response = await fetch(ordersExportEndpoint + uId, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/vnd.ms-excel',
          },
        });
        if (response.ok) {
          const blob = await response.blob();
          const url = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'filename.xlsx'); // specify the file name
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
        } else {
          toast.error("Failed to export orders", {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 5000,
            paueOnHover: true,
            theme: 'colored'
          });
        }
      } catch (error) {
        console.error('Failed to export orders', error);
        toast.error("Failed to export orders", {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 5000,
          paueOnHover: true,
          theme: 'colored'
        });
      }
    }
  }

  const buildNoRecordsMsg = () => {
    var msg;
    if (loading) {
      msg = "Loading...please wait";
    } else if ((selectedParentID && selectedParentID !== 0) || (selectedCompanyID && selectedCompanyID !== 0)) {
      msg = "No Orders found.";
    } else {
      msg = "Please select a Customer. You must be associated with the Customer’s assigned Account Owner to view Orders.";
    }
    setNoRecordsMessage(msg);
  };

  const buildFilterMsg = () => {
    //displaying first {totalDisplayed} Orders of {totalRecords} | {filterTotal} filters applied
    //displaying next  {totalDisplayed} Orders of {totalRecords} | {filterTotal} filters applied
    //displaying last  {totalDisplayed} Orders of {totalRecords} | {filterTotal} filters applied
    //displaying first {totalDisplayed} Orders of {totalRecords} found | {filterTotal} filters applied
    var msg;
    if (loading) {
      msg = "Loading...please wait";
    } else {
      msg = 'displaying '
        + (currentPage === 1 ? 'first' : currentPage === totalPages ? 'last' : 'next')
        + ' ' + totalDisplayed + ' Orders of ' + totalRecords + (filterTotal !== 0 ? ' found ' : '') + " | " + filterTotal + ' filters applied.';
    }
    setFilterDescription(msg);
  };

  const clearFilters = () => {

    //const identity = jwtDecode(storedToken);

    orderFilters.parentId = selectedCompanyParentID ? selectedCompanyParentID : selectedParentID;
    orderFilters.companyId = selectedCompanyID;
    orderFilters.contactId = 0;
    orderFilters.contactName = "";
    orderFilters.salesRepId = 0;
    orderFilters.activityType = 0;
    orderFilters.recurrence = - 1;
    orderFilters.status = 0;
    orderFilters.dateType = "order";
    orderFilters.dateRange = 0;
    orderFilters.dateRangeStart = formatDate(new Date('01/01/1980'));
    orderFilters.dateRangeEnd = next(7);

    orderFilters.filterTotal = 1;
    orderFilters.applyFilter = false;
    orderFilters.product = "";
    orderFilters.order = "";
    setOrderFilters(orderFilters);
  };

  const resetFilters = () => {
    //setIndividualFilter(defaultIndividualFilter);
    clearFilters();
    setfilterTotal(0);
  };

  const setModalFilters = async (updatedFilters) => {
    // Update the orderFilters state with the new filters
    setOrderFilters(updatedFilters);
    // fetchOrders will be called automatically via useEffect when orderFilters changes
  };

  const setSearchFilters = () => {

    let of = { ...orderFilters };

    if (searchOptions && searchOptions.mode) {
      setOrderFilters(of);
      setSearchOptions({ mode: 0, value: 0, data: "" });
    }

    return of;

  };

  const failedCustomerUid = () => {
    toast.error("Failed to find customer identifiers", {
      position: toast.POSITION.BOTTOM_RIGHT,
      autoClose: 5000,
      paueOnHover: true,
      theme: 'colored'
    }); 
  };

  const openSearchForm = () => {
    setSearchForm(true);
  };
  const closeSearchForm = () => {
    setSearchForm(false);
  };
  
  useEffect(() => {
    setCollapseButtonText(allCollapsed ? 'Expand All' : 'Collapse All');
  }, [allCollapsed]);


  //filter message
  useEffect(() => {
    buildFilterMsg();
  }, [loading, currentPage, totalPages, totalDisplayed, totalRecords, filterTotal, orderFilters]);

  //no records message
  useEffect(() => {
    buildNoRecordsMsg();
  }, [selectedParentID, selectedCompanyID, loading]);

  //load search filters
  useEffect(() => {
    //fetchIndividualFilters(); //used in individual filter dropdown

  }, [selectedParentID, selectedCompanyID]);

  //load order cards
  useEffect(() => {
    console.log("order filters: ",orderFilters);
    fetchOrders();
  }, [selectedParentID, selectedCompanyID, currentPage, sortOption, displayOption, orderFilters]);

  return (
    <>
      <div className="sticky-top">

        <Nav className='navbar navbar-expand-lg nav-card-actions'>
          <div className='container'>
            <div className='page-title-row row'>
              <div className='col-sm-12 col-md-auto page-title-wrapper'>
                <div className='navbar-text page-title'>Orders</div>
              </div>
              <div className='col-sm-12 col-md-6'>
                <div className='navbar-text filter-description'>
                  {filterDescription}
                  {filterTotal !== 0 ?
                    <Button className="remove-filter-link" onClick={resetFilters}>remove filters</Button>
                    : null}
                </div>
              </div>
            </div>
          {/*  <div className='d-flex'>*/}
          {/*    <button className='btn btn-outline-info btn-add-contact' onClick={openOrderForm}>*/}
          {/*      <div className='hidden-sm-down'>Edit Order</div>*/}
          {/*    </button>*/}
          {/*  </div>*/}
          </div>
        </Nav>

        <Nav className='navbar navbar-expand-lg nav-card-dropdowns justify-content-end'>
          <div className='container'>

            <div className='row filter-grid'>

              <div className='col-md-2'>
                <div className='row'>
                  <div className='col-auto filter-item-collapse'>
                    <Button className='btn-collapse export-button' variant="primary" onClick={requestExcelExport}>
                      <i className="fa-file-excel-o fa fa-expand" aria-hidden="true" />
                      <span className='export-button-label'>Excel</span>
                    </Button>
                    {/* <Button disabled className='btn-collapse export-button' variant="primary" onClick={requestPDFExport}>
                      <i className="fa-file-pdf-o fa fa-expand" aria-hidden="true" />
                      <span className='export-button-label'>PDF</span>
                    </Button> */}
                  </div>
                </div>
              </div>
              <div className='col-md-10'>
                <div className='d-flex flex-row-reverse'>
                  <div className='row'>
                  <div className='col-auto filter-item-collapse'>
                    {/* <div className='d-flex'>
                      <div className='grid-toggle-wrapper'>
                        <label style={{ "padding-right": "10px" }}>
                          Grid View:
                        </label>
                        <ToggleButton 
                          onToggle={handleGridToggle}
                          isToggled={gridView}
                        />
                      </div>
                    </div> */}
                    <Button className='btn-collapse' variant="primary" onClick={handleToggleCollapse}>
                      {collapseButtonText}<i className={collapseButtonText === 'Collapse All' ? "i-collapse fa fa-compress" : "i-collapse fa fa-expand"} aria-hidden="true" />
                    </Button>
                  </div>
                    <div className='col-auto filter-item-display'>
                      <FloatingLabel className="floating-select" label={`Display/Page:`}>
                        <Select
                          className="filter-contact-display"
                          classNamePrefix="select"
                          options={displayOptions}
                          value={displayOption}
                          onChange={handleDisplayChange}
                        />
                      </FloatingLabel>

                    </div>
                    <div className='col-auto filter-item-alpha'>
                    <FloatingLabel className="floating-select" label={`Sort by:`}>
                      <Select
                        className="filter-contact-sort"
                        classNamePrefix="select"
                        options={sortOptions}
                        value={sortOption}
                        onChange={handleSortChange}
                      />
                    </FloatingLabel>
                    </div>
                    <div className='col-auto'>
                      <div className='d-flex'>
                        <Button className="search-button" variant="primary" onClick={openSearchForm}>Search...</Button>
                      </div>
                    </div>
                  </div>

                </div>
                  
              </div>
              
            </div>
          </div>
        </Nav>


        {orders && totalRecords > displayOption.value ? (
          <div className='navbar navbar-expand-lg nav-card-pagination'>
            <div className='pagination-wrapper'>
              <Pagination>
                <Pagination.First onClick={handleFirstPage}>
                  <i className="fa fa-angle-double-left pagination-icon-left" aria-hidden="true" />
                  First
                </Pagination.First>
                <Pagination.Prev onClick={handlePrevPage}>
                  <i className="fa fa-angle-left pagination-icon-left" aria-hidden="true" />
                  Previous
                </Pagination.Prev>
                {renderPaginationItems()}
                <Pagination.Next onClick={handleNextPage}>
                  Next
                  <i className="fa fa-angle-right pagination-icon-right" aria-hidden="true" />
                </Pagination.Next>
                <Pagination.Last onClick={handleLastPage}>
                  Last
                  <i className="fa fa-angle-double-right pagination-icon-right" aria-hidden="true" />
                </Pagination.Last>
              </Pagination>
            </div>
          </div>
        ) : (
          <div className="pagination-grid-empty"></div>
        )}

      </div>

      <OrderForm showModal={showOrderForm} closeModal={closeOrderForm} orderInfo={orderSelected}></OrderForm>
      <OrderSearch showModal={showSearchForm} closeModal={closeSearchForm} orderFilters={orderFilters} setOrderFilters={setModalFilters}></OrderSearch>
      <div className='container'>
        {orders && orders.length > 0 ? (
          <div className={loading ? 'cards-loading' : 'cards-loaded'}>
              {orders.map((order, index) => (
                <OrderCard
                  key={index}
                  order={order}
                  eventKey={String(allCollapsed)}
                  loading={loading}
                  editOrder={(e, value) => openOrderForm(e, value)}
                />
              ))}
          </div>
          ) : (
          <AlertElement textBody={noRecordsMessage} />
          )}
      </div>
    </>
  );
};